/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { UserDocumentFolder } from './UserDocumentFolder'
import {
  UserDocumentFolderFromJSON,
  UserDocumentFolderFromJSONTyped,
  UserDocumentFolderToJSON,
} from './UserDocumentFolder'
import type { GetUserDocumentList200ResponsePagination } from './GetUserDocumentList200ResponsePagination'
import {
  GetUserDocumentList200ResponsePaginationFromJSON,
  GetUserDocumentList200ResponsePaginationFromJSONTyped,
  GetUserDocumentList200ResponsePaginationToJSON,
} from './GetUserDocumentList200ResponsePagination'

/**
 *
 * @export
 * @interface GetUserDocumentList200Response
 */
export interface GetUserDocumentList200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetUserDocumentList200Response
   */
  status: boolean
  /**
   *
   * @type {Array<UserDocumentFolder>}
   * @memberof GetUserDocumentList200Response
   */
  data: Array<UserDocumentFolder>
  /**
   *
   * @type {GetUserDocumentList200ResponsePagination}
   * @memberof GetUserDocumentList200Response
   */
  pagination?: GetUserDocumentList200ResponsePagination
}

/**
 * Check if a given object implements the GetUserDocumentList200Response interface.
 */
export function instanceOfGetUserDocumentList200Response(
  value: object
): value is GetUserDocumentList200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetUserDocumentList200ResponseFromJSON(
  json: any
): GetUserDocumentList200Response {
  return GetUserDocumentList200ResponseFromJSONTyped(json, false)
}

export function GetUserDocumentList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetUserDocumentList200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(UserDocumentFolderFromJSON),
    pagination:
      json['pagination'] == null
        ? undefined
        : GetUserDocumentList200ResponsePaginationFromJSON(json['pagination']),
  }
}

export function GetUserDocumentList200ResponseToJSON(
  value?: GetUserDocumentList200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(UserDocumentFolderToJSON),
    pagination: GetUserDocumentList200ResponsePaginationToJSON(
      value['pagination']
    ),
  }
}
